import { useContext } from "react";
import { SellarSessionContext } from "../contexts/SellarSessionContext";

export const useSellarCurrentBusiness = () => {
  const context = useContext(SellarSessionContext);
  if (context === undefined) {
    throw new Error(
      "useSellarCurrentBusiness must be within SellarSessionProvider",
    );
  }

  const isAdmin =
    context.firebase.user?.isAdmin === true ||
    context.sellar.user?.type === "admin";

  return {
    ...context.currentBusiness,
    isNonMemberAdmin:
      isAdmin && context.currentBusiness.business?.BusinessUser === null,
  };
};
